import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';

import ArgType from '../ArgType';
import FunctionCategory from '../FunctionCategory';

export default {
  name: 'FACT',
  category: FunctionCategory.MATH,
  shortDescription: 'Factorial of a number.',
  description: 'Returns the factorial of a number.',
  params: [
    {
      name: 'value',
      // TODO(BNCH-114117): Sheets throws a #NUM! error if value > 170 since that would be above the max
      // integer limit. We should do the same instead of returning Infinity.
      type: ArgType.nonnegativeNumber,
      description: 'The number whose factorial will be calculated and returned.',
    },
  ],

  eval: (value: number): number => {
    value = Math.floor(value);
    if (value === 0) {
      return 1;
    }
    for (let i = value - 1; i >= 1; i--) {
      value *= i;
      if (value === Infinity) {
        return Infinity;
      }
    }

    return value;
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
